<template>
    <span :class="displayAltCached">
        <img v-if="displayIco" :src="displayIco" :alt="displayAltCached" :title="displayAltCached" :class="iconClass"
             :height="iconSize"/>
    </span>
</template>

<script>
import {getActiveThirdPartyPlatformList} from "@helpers/api-helper";

export default {
    name: "ThirdPartyPlatformIcon",
    props: {
        platform: {
            type: String,
            default: '',
        },
        iconSize: {
            type: String,
            default: '18',
        },
        iconClass: {
            type: String,
            default: 'mb-1 mr-1',
        },
        displayAlt: {
            type: String,
            default: '',
        },
        referringPlatformUuid: {
            type: String,
            default: null,
        }
    },
    data: () => ({
        referringPlatform: null,
    }),
    computed: {
        linkedPlatform() {
            return this.referringPlatform?.slug || this.platform;
        },
        displayAltCached() {
            if (this.displayAlt) {
                return this.displayAlt;
            }
            switch (this.linkedPlatform) {
                case 'lonewolf':
                case 'zipform':
                    return 'Linked to your zipForm account';
                case 'dotloop':
                    return 'Linked to your dotLoop account';
            }
        },
        displayIco() {
            switch (this.linkedPlatform) {
                case 'lonewolf':
                case 'zipform':
                    return require('@assets/images/zipForm.png');
                case 'dotloop':
                    return require('@assets/images/v3/dotloop_v3.svg');
            }
            return null;
        }
    },

    async created() {
        let uuid = this.referringPlatformUuid;
        if (Boolean(uuid)) {
            this.referringPlatform = (await getActiveThirdPartyPlatformList()).find(p => [p?.uuid, p?._uuid].includes(uuid)) || null;
        }
    }
}
</script>